import React from 'react';

const Error = (props: object) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 15V23.3333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9997 35.6828H9.89973C4.11639 35.6828 1.69973 31.5495 4.49973 26.4995L9.69973 17.1328L14.5997 8.33281C17.5664 2.98281 22.4331 2.98281 25.3997 8.33281L30.2997 17.1495L35.4997 26.5161C38.2997 31.5661 35.8664 35.6995 30.0997 35.6995H19.9997V35.6828Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9922 28.333H20.0072"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Error;
